import { Component, Input } from '@angular/core';
import { ConfigService } from 'src/app/tools/services/config.service';
import { GenericMenu } from 'src/app/tools/abstract-classes/generic-menu';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'assabil-sales-menu',
  templateUrl: './assabil-sales-menu.component.html',
  styleUrls: ['./assabil-sales-menu.component.scss']
})

export class AssabilSalesMenuComponent extends GenericMenu {

  @Input() shrinkMode : boolean = false;


  // warehouse = {
  // 'id'          : 'branch',
  // 'title'       : 'Gestion du Dépôt',
  // 'prefix'      : 'V',
  // 'blocs'  :  [
  //                   {
  //                     'id'         : 'branch-warehouse',
  //                     'title'      : 'Achat - Stock',
  //                     'icon'       :  'assets/images/icons/mobile-app.png',
  //                     'items'      : [
  //                             {
  //                               'id'        : 'branch-warehouse-porder'  ,
  //                               'label'     : 'Programme Fidélité',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/loyalty-program'
  //                             },
  //                             {
  //                               'id'        : 'branch-warehouse-porder'  ,
  //                               'label'     : 'Programme Fidélité Release',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/loyalty-program-release'
  //                             },
                        
  //                             {
  //                               'id'        : 'branch-warehouse-porder'  ,
  //                               'label'     : 'Bons de commande Achat',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-porder'
  //                             },
  //                             {
  //                               'id'        : 'branch-warehouse-transfers'  ,
  //                               'label'     : 'Demandes de Transfert',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-transfers'
  //                             },
  //                             {
  //                               'id'        : 'branch-warehouse-input'  ,
  //                               'label'     : 'Entrée Stock',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-input'
  //                             },
  //                             {
  //                               'id'        : 'branch-warehouse-output'  ,
  //                               'label'     : 'Sortie Stock',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-output'
  //                             },
  //                             {
  //                               'id'        : 'branch-warehouse-inventory'  ,
  //                               'label'     : 'Inventaires',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-inventorys'
  //                             },                                      
  //                             {
  //                               'id'        : 'branch-warehouse-input'  ,
  //                               'label'     : 'Dispatch',
  //                               'icon'      : "assets/icons/invoice.png",
  //                               'route'     : './sales/branch-warehouse-dispatch'
  //                             },
  //                           ]
  //                   },

  //                   {
  //                     'id'         : 'branch-sales',
  //                     'title'      : 'Comptoir',
  //                     'icon'       :  'assets/images/icons/mobile-app.png',
  //                     'items'      : [
  //                                     {
  //                                       'id'        : 'branch-sales-invoicing'  ,
  //                                       'label'     : 'Facturation Agence',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/branch-sales-invoicing'
  //                                     }, 
  //                                     {
  //                                       'id'        : 'branch-sales-order'  ,
  //                                       'label'     : 'Bons de commande',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/branch-sales-order'
  //                                     }
  //                                   ]
  //                   },
  //                   {
  //                     'id'         : 'branch-settlement',
  //                     'title'      : 'Décompte',
  //                     'icon'       :  'assets/images/icons/mobile-app.png',
  //                     'items'      : [
  //                                     {
  //                                       'id'        : 'branch-settlement'  ,
  //                                       'label'     : 'Décompte Vendeur',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/branch-settlement'
  //                                     },
  //                                     { 
  //                                       'id'        : 'branch-settlement'  ,
  //                                       'label'     : 'Paiements',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/branch-payment'
  //                                     }
  //                                   ]
  //                   },
  //               ]    
  // };  


sales = {
  'id'          : 'sales',
  'title'       : 'Gestion des Ventes',
  'prefix'      : 'V',
  'blocs'  :  [
                    {
                      'id'         : 'sales-supervision',
                      'title'      : 'Supervision',
                      'icon'       :  'assets/images/icons/mobile-app.png',
                      'items'      : [
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Sales Monitoring",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sales-monitoring'
                                      },
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Dashboard Perf globale",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/role-target-monitoring'
                                      }, 
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Suivi Quanti Toujjar Bladi",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sales-loyalty-monitoring'
                                      }, 
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Suivi Quali Toujjar Bladi",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sales-loyalty-quality-monitoring'
                                      }, 
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Suivi Conso. Primes",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sales-loyalty-bonus-followup-monitoring'
                                      }, 
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Clients exclus",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sales-excluded-partner'
                                      },
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "DN SIP Monitoring",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/sip-monitoring'
                                      },
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Taux de Service",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/service-rate-monitoring'
                                      },
/*                                       {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "DN MSL Monitoring",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/msl-monitoring'
                                      },
                                      {
                                        'id'        : 'sales-supervision-monitoring'  ,
                                        'label'     : "Respect MSL Monitoring",
                                        'icon'      : "assets/icons/invoice.png",
                                        'route'     : './sales/msl-respect-monitoring'
                                      }, */
                                      {
                                          'id'        : 'sales-supervision-reports'  ,
                                          'label'     : 'Rapports',
                                          'icon'      : 'assets/icons/invoice.png',
                                          'route'     : ''
                                      }
                                    ]
                    },
  //                   {
  //                     'id'         : 'sales-branch-admin',
  //                     'title'      : 'Admin. Agence',
  //                     'icon'       :  'assets/images/icons/mobile-app.png',
  //                     'items'      : [
  //                                     {
  //                                       'id'        : 'sales-branch-admin-msl',
  //                                       'label'     : 'Paramétres MSL',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/danone-msl-product'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-branch-admin-dn',
  //                                       'label'     : "Paramétres DN",
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/danone-dn-product-family'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-branch-admin-rate',
  //                                       'label'     : "Quotas prévente %",
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/role-product-rate'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-branch-admin-quota',
  //                                       'label'     : "Quotas prévente Qtés",
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/role-product-quota'
  //                                     }
  //                                   ]
  //                   },
  //                   {
  //                     'id'         : 'sales-admin',
  //                     'title'      : 'Master Data',
  //                     'icon'       :  'assets/images/icons/mobile-app.png',
  //                     'items'      : [
  //                                     {
  //                                       'id'        : 'sales-admin-promo' ,
  //                                       'label'     : 'Promotions',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/promo'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-admin-promo-simulation' ,
  //                                       'label'     : 'Simulation',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/promo-simulation'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-admin-promo-product-family',
  //                                       'label'     : 'Familles Produits',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/promo-product-family'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-admin-promo-partner-family' ,
  //                                       'label'     : 'Familles Clients',
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/promo-partner-family'
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-admin-target-type' ,
  //                                       'label'     : "Type d'Objectif",
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/target-type',
  //                                     },
  //                                     {
  //                                       'id'        : 'sales-admin-role-target' ,
  //                                       'label'     : "Objectifs des Roles",
  //                                       'icon'      : "assets/icons/invoice.png",
  //                                       'route'     : './sales/role-target',
  //                                     },

                                      
  //                                   ]
  //                   },

                  ]
  };

  
  constructor(
    protected router              : Router,
    protected configService       : ConfigService,
    protected activatedRoute      : ActivatedRoute,
  ) { 
    super(router, activatedRoute);
  }

  ngOnInit() {
  }
  

  select(itemId : string){
    if (itemId == 'sales-supervision-reports') {
      this.openReports();
    }
  }
  
  openReports(){
    let url= this.configService.config.salesReportsAppUrl;
    window.open(url)
  }

}
